import { Card } from "../../ui";

export default function MetricCard({ icon: Icon, value, label, variant = "primary" }) {
  return (
    <Card className="lud-notif-metric-card">
  <div className="lud-notif-metric-top">
    <div className={`lud-notif-metric-icon lud-notif-metric-icon--${variant}`}>
      <Icon size={18} />
    </div>

    <div className="lud-notif-metric-value">
      {value}
    </div>
  </div>

  <div className="lud-notif-metric-label">
    {label}
  </div>
</Card>
  );
}
